import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.22003 6.5L6.49003 6.23C6.624 6.09042 6.80672 6.00802 7.00003 6H13.5C13.6326 6 13.7598 6.05268 13.8536 6.14645C13.9473 6.24021 14 6.36739 14 6.5V7.5C14 7.63261 13.9473 7.75979 13.8536 7.85355C13.7598 7.94732 13.6326 8 13.5 8H9.41003L17.85 16.44C17.8969 16.4865 17.9341 16.5418 17.9595 16.6027C17.9849 16.6636 17.9979 16.729 17.9979 16.795C17.9979 16.861 17.9849 16.9264 17.9595 16.9873C17.9341 17.0482 17.8969 17.1035 17.85 17.15L17.15 17.85C17.1035 17.8969 17.0482 17.9341 16.9873 17.9594C16.9264 17.9848 16.861 17.9979 16.795 17.9979C16.729 17.9979 16.6637 17.9848 16.6027 17.9594C16.5418 17.9341 16.4865 17.8969 16.44 17.85L8.00003 9.42V13.5C8.00003 13.6326 7.94735 13.7598 7.85358 13.8536C7.75981 13.9473 7.63263 14 7.50003 14H6.50003C6.36742 14 6.24024 13.9473 6.14647 13.8536C6.0527 13.7598 6.00003 13.6326 6.00003 13.5V7C6.00539 6.80811 6.08413 6.62558 6.22003 6.49V6.5Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgExpandLeftOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgExpandLeftOutline;
